import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { useTimelineMapService } from "@features/Pages/TimelineMapPage/_js/app/services/timelineMapService";
import {computed, onMounted} from "vue";
import { useDragScroll } from "./services/jvm/dragscroll";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import Modal from "@features/Pages/TimelineMapPage/_js/app/components/modal/Modal.vue";
import SpinnerJvm from '@shared/spinner/spinner-jvm.vue';
import SpinnerMm from '@shared/spinner/spinner-mm.vue';
import SpinnerVrak from '@shared/spinner/spinner-vrak.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useTimelineMapStore();
const { 
  registerScrollListener,
  scrollToMoment,
  registerParallax,
  getHostname,
  getShowMap,
  getShowMomentsList,
  getTimelineMapData,
  getMapboxConfig,
  getTranslations,
  getModalContent 
} = useTimelineMapService();

const spinnerComponent = computed(() => {
  const mapping = {
    jvm: SpinnerJvm,
    mm: SpinnerMm,
    vrak: SpinnerVrak,
  };

  if (store.isJVM) return mapping.jvm;
  if (store.isMM) return mapping.mm;
  if (store.isVRAK) return mapping.vrak;

  return SpinnerMm;
});

onMounted(() => {
  getHostname();
  getShowMap();
  getShowMomentsList();
  getTimelineMapData();
  getTranslations();
  getModalContent();

  if (store.isJVM || store.isMM) {
    useDragScroll('timeline');
    registerScrollListener();
    scrollToMoment();
    registerParallax();
  }
  
  if (store.isVRAK) {
    getMapboxConfig();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(Modal, {
      id: _unref(store).activeMoment.urlSegment,
      onCloseModal: _unref(store).onCloseModal
    }, {
      content: _withCtx(() => [
        (_unref(store).activeMoment.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(spinnerComponent.value)))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: _unref(store).activeMoment.modalContent
            }, null, 8 /* PROPS */, _hoisted_2))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["id", "onCloseModal"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})